<template>
  <div class="manual-title">
    <h1 class="visually-hidden">Как играть?</h1>
    <picture class="manual-title__picture">
      <source type="image/webp" srcset="~@/assets/img/manual/text-title.webp" />
      <img
        class="manual-title__img"
        src="~@/assets/img/manual/text-title.png"
        alt="Как играть?"
      />
    </picture>
  </div>
</template>

<script>
export default {
  name: "ManualTitle"
};
</script>

<style lang="scss">
.manual-title {
  &__picture {
    display: block;
    margin: 150px 0 170px;
  }

  &__img {
    filter: drop-shadow(0 16px 30px #000);
    max-width: 90%;
    display: block;
    margin: 0 auto;
  }

  @include breakpoint("sm-and-down") {
    &__picture {
      display: block;
      margin: 10% 0 12%;
    }
  }
}
</style>
